// import Promise from 'es6-promise'
import axios from 'axios'
// 参考
// http://chibinowa.net/note/vuejs/vue-14.html

// resolve
const apiSuccess = (response) => Promise.resolve(response)
// reject
const apiError = (error) => Promise.reject(error.response || error || 'ERROR')

// const idApiUrl = (document.URL.match('localhost') !== null) ? 'http://localhost:3000/' : (document.URL.match('dev-www') !== null) ? 'https://dev-id-api.j-cast.com/' : 'https://id-api.j-cast.com/'

// これ 18.5.18
// api 本番 開発 他でも使用するので設定ファイルみたいに外部に出したい
const userApiURL = {
  'jnews': { // prod:本番 dev:開発
    'prod': 'https://id-api.j-cast.com',
    'dev': 'https://dev-id-api.j-cast.com'
  },
  'tbm': {
    'prod': 'https://id-api.bg-mania.jp',
    'dev': 'https://dev-id-api.bg-mania.jp'
  }
}
const site = (document.URL.match('j-cast') !== null) ? 'jnews' : 'tbm'
const env = (document.URL.match('dev-www') !== null) ? 'dev' : 'prod'
const idApiUrl = userApiURL[site][env]
// const idApiUrl = 'https://id-api.j-cast.com/'

axios.defaults.withCredentials = true

export default {
  // ログインユーザー情報取得
  getUser: () =>
    axios.get(idApiUrl + 'user/').then(apiSuccess).catch(apiError),

  // 記事コメント一覧情報取得 current commentData.page
  getComments: function (commentData) {
    // コメント一覧 か ピックアップ
    if (commentData.pageType === 'comment') {
      // コメント一覧
      return axios.get(idApiUrl + '/comments/' + commentData.entry_id, {params: {page: commentData.page || 1}}).then(apiSuccess).catch(apiError)
    } else {
      // ピックアップ
      return axios.get(idApiUrl + '/comments/' + commentData.entry_id + '/pickup').then(apiSuccess).catch(apiError)
    }
  },

  // 記事コメント一覧情報取得 current payload.pager.replyPageCurrent
  getReplyComments: function (replyData) {
    // console.log(replyData, 'replyData')
    return axios.get(idApiUrl + '/comments/' + replyData.entry_id + '/' + replyData.replyKey + '/reply', {params: {page: replyData.pager.replyPageCurrent || 1}}).then(apiSuccess).catch(apiError)
  },

  // コメント投稿
  postComment: function (postContents) {
    // console.log(postContents, 'postContents')
    // postするコメントは 通常コメント 返信コメント か
    if (!(postContents.replyPostFlag)) {
      // 通常コメント
      return axios.post(idApiUrl + '/comments/' + postContents.entryID, postContents.postBody).then(apiSuccess).catch(apiError)
    } else {
      // 返信コメント
      return axios.post(idApiUrl + '/comments/' + postContents.entryID + '/' + postContents.replyKey + '/reply', postContents.postBody).then(apiSuccess).catch(apiError)
    }
  },

  // コメント削除
  deleteComment: function (deletion) {
    // console.log(deletion, 'postContents')
    // deleteするコメントは 通常コメント 返信コメント か
    if (!(deletion.replyDeleteFlag)) {
      // 通常コメント
      return axios.put(idApiUrl + '/comments/' + deletion.entryID + '/' + deletion.uuid).then(apiSuccess).catch(apiError)
    } else {
      // 返信コメント
      return axios.put(idApiUrl + '/comments/' + deletion.entryID + '/' + deletion.replyKey + '/reply/' + deletion.uuid).then(apiSuccess).catch(apiError)
    }
  },

  // 通報投稿
  postReport: function (postReport) {
    // console.log(postReport, 'postReport')
    // postするコメントは 通常コメント 返信コメント か
    if (!(postReport.replyReportFlag)) {
      // 通報：通常コメント
      return axios.post(idApiUrl + '/comments/' + postReport.entryID + '/' + postReport.uuid + '/report', postReport.postBody).then(apiSuccess).catch(apiError)
    } else {
      // 通報：返信コメント
      return axios.post(idApiUrl + '/comments/' + postReport.entryID + '/' + postReport.replyKey + '/reply/' + postReport.uuid + '/report', postReport.postBody).then(apiSuccess).catch(apiError)
    }
  },

  // good bad 名前はpostVoteが良いか
  voteComment: function (vote) {
    // console.log(vote, 'vote')
    // deleteするコメントは 通常コメント 返信コメント か
    if (!(vote.replyVoteFlag)) {
      // 通常コメント good bad
      return axios.post(idApiUrl + '/comments/' + vote.entryID + '/' + vote.uuid + '/' + vote.goodBad).then(apiSuccess).catch(apiError)
    } else {
      // 返信コメント good bad
      return axios.post(idApiUrl + '/comments/' + vote.entryID + '/' + vote.replyKey + '/reply/' + vote.uuid + '/' + vote.goodBad).then(apiSuccess).catch(apiError)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/commentApi.js